/*global MatchSocket*/
var MobileMatch = function() {
    return {
        init: function(mid) {
            MatchSocket.init(mid);

            $('.tabs__item').click(function() {
                var scrollto = $('.tab-content').offset().top - 160;
                if ($(document).scrollTop() >= scrollto) {
                    $(document).scrollTop(scrollto);
                }
                if ($(this).hasClass('ii__analysi')) {
                    Generic.change_hash_without_scroll('#analysi');
                    $('.sticky-bubble').show();
                    $('.ii__trigger_analyseis').show();
                } else {
                    Generic.change_hash_without_scroll('');
                    $('.sticky-bubble').hide();
                    $('.ii__trigger_analyseis').hide();
                }
            });
            if (window.location.hash.indexOf('#analysi', 0) == 0 && $('.ii__analysi').length > 0) {
                $('.ii__analysi').trigger('click');
            }

            $('.ii__sticky-bubble').click(function() {
                $('#sticky-list').toggle();
                $('body').toggleClass('modal-open');
            });
            $('#close-bubble').click(function() {
                $('#sticky-list').hide();
                $('body').removeClass('modal-open');
            });

            $('.ii__h2h_list_toggler').click(function() {
                $('#h2h_list').toggle();
                if ($('#h2h_list').is(':visible')) {
                    $(this).find('i.icon').removeClass('fa-caret-down').addClass('fa-caret-up');
                } else {
                    $(this).find('i.icon').removeClass('fa-caret-up').addClass('fa-caret-down');
                }
            });
            $('.ii__matchpage_tab').click(function() {
                MobileMatch.recordTabClick(this);
            });
            MobileGeneric.initMatchArticleTabTrigger();
            MobileGeneric.initMatchHistory(false);
            Generic.init_popovers();
            Vote.init();
            MobileGeneric.initMoreAnalyseis();
            Star.initMatchStarHandler();
            MatchStats.registerBtnHandlers();
            setTimeout(function() {
                MobileMatch.refreshLoop(mid, false, $('.ii__live_part'));
            }, 20 * 1000);
        },
        recordTabClick: (elem) => {
            let tabname = $(elem).data('tabname');
            if (!tabname) {
                return;
            }
            ActionTracker.record('matchpage-tab-' + tabname + '-mobile');
        },
        refresh: function(mid, full_update, targetElem) {
            return Ajax.getMobileMatchPage(false, mid, full_update, function(res) {
                if (res.success != 'ok') {
                    return;
                }
                const currentMid = targetElem.data('mid');
                if (currentMid && currentMid != mid) { // user has opened another match
                    return;
                }
                targetElem.html(res.html);
                if (!full_update) {
                    Commentaries.load(mid);
                    MatchStats.refresh(mid);
                } else {
                    Vote.init();  // bind vote button click handlers on full reload
                }
                MobileGeneric.initMatchHistory(true);
                MobileGeneric.initMoreAnalyseis();
                Generic.init_popovers();
            });
        },
        refreshLoop: function(mid, full_update, targetElem) {
            MobileMatch.refresh(mid, full_update, targetElem).finally(function() {
                setTimeout(function() {
                    MobileMatch.refreshLoop(mid, full_update, targetElem);
                }, 20 * 1000);
            });
        },
        saveOddsCompany: function(odds_company_id) {
            Generic.showProgressLoader();
            Ajax.savePrefOddsCompany(odds_company_id, () => {
                top.location.href = top.location.href;
            });
        }
    };
}();

if (typeof module !== 'undefined') {
    module.exports = MobileMatch;
}
